import PropTypes from 'prop-types'
import React from 'react'
import { Radio, Form, Message } from 'semantic-ui-react'

import { Condition } from 'components/Condition'

export class DistributionSetting extends React.Component {
  static propTypes = {
    defaultValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    plan: PropTypes.object.isRequired,
    numbersOfSpreadEmails: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([''])]),
  }

  static defaultProps = {
    onChange: () => {},
    plan: { metadata: {} },
  }

  state = {
    value: '',
  }

  componentDidMount() {
    if (this.props.defaultValue) {
      this.setState({ value: this.props.defaultValue })
    }
  }

  handleChange = (_, { value }) => {
    this.setState({ value })
    this.props.onChange(value)
  }

  render() {
    return (
      <React.Fragment>
        <h3>Distribution</h3>
        <p>Choose if emails are sent immediately over spread out over time.</p>
        <p>
          <a
            href="https://help.simplesat.io/en/articles/2220503-direct-email-surveys#distribution"
            target="_blank"
            rel="noreferrer"
          >
            <i className="icon far fa-book" />
            Email distribution types for surveys
          </a>
        </p>
        <Form>
          <Form.Field>
            <Radio
              label="Spread out delivery evenly over time (recommended)"
              value="spread"
              name="distribution"
              checked={this.state.value === 'spread'}
              onChange={this.handleChange}
            />
          </Form.Field>
          <Condition.True condition={this.state.value === 'spread'}>
            <Message>
              Your audience rules are configured to send about{' '}
              <strong>{this.props.numbersOfSpreadEmails} emails</strong> per day.
            </Message>
          </Condition.True>
          <Form.Field>
            <Radio
              label="Deliver emails as soon as possible"
              value="immediately"
              name="distribution"
              checked={this.state.value === 'immediately'}
              onChange={this.handleChange}
            />
          </Form.Field>
        </Form>
        <div className="ui warning message">
          <p>
            The {this.props.plan.nickname} plan limits sending{' '}
            <strong>{this.props.plan.metadata.daily_sending_limit} emails</strong> per day.
          </p>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/DistributionSetting/index.js